// extracted by mini-css-extract-plugin
export default {"drop":"UploadDropZone_drop__66aHY","dropOver":"UploadDropZone_dropOver__hZ7iV"};